/**
 * Normalize and validate a host-pasted YouTube URL for Unit Item reference.
 * Accepts watch, Shorts, embed, youtu.be, m.youtube, youtube-nocookie.
 */
export function normalizeYoutubeReferenceUrl(raw: string): string | null {
  const s = raw.trim();
  if (!s) return null;
  try {
    const url = new URL(
      s.startsWith("http://") || s.startsWith("https://") ? s : `https://${s}`
    );
    const host = url.hostname.replace(/^www\./i, "").toLowerCase();
    if (host === "youtu.be") {
      if (url.pathname.length <= 1) return null;
      return url.toString();
    }
    if (
      host === "youtube.com" ||
      host === "m.youtube.com" ||
      host === "youtube-nocookie.com"
    ) {
      if (url.pathname.startsWith("/watch")) {
        return url.searchParams.get("v") ? url.toString() : null;
      }
      if (url.pathname.startsWith("/embed/") || url.pathname.startsWith("/shorts/")) {
        return url.toString();
      }
      return null;
    }
    return null;
  } catch {
    return null;
  }
}
